<template>
  <fragment>
    <v-row>
      <v-col cols="12" md="8">
        <v-card width="100%" class="pa-4 mr-6" flat>
          <v-container class="mt-3 mb-5 d-flex justify-center">
            <v-chip class="px-10" style="color: white" color="#2d1a4c" large>
              {{ $t("marketing.invitation.customize-invitation") }}
            </v-chip>
          </v-container>
          <v-row>
            <v-form
              @submit.prevent="sendTestInvite"
              class="search-forms"
              ref="form"
            >
              <v-col cols="12">
                <BaseTextField
                  :label="$t('marketing.invitation.subject')"
                  required
                  type="text"
                  hide-details
                  v-model="assunto"
                  :rules="[rules.required]"
                >
                </BaseTextField>
              </v-col>
              <v-col cols="12">
                <BaseTextField
                  :label="$t('marketing.invitation.sender')"
                  required
                  type="text"
                  hide-details
                  v-model="remetente"
                  :rules="[rules.required]"
                >
                </BaseTextField>
              </v-col>
              <v-col cols="12">
                <editor
                  v-model="mensagem"
                  :placeholder="$t('marketing.invitation.insert-message-here')"
                  class="editor-input heigh-input"
                  :rules="[rules.required]"
                  :customToolbar="customToolbar"
                >
                </editor>
              </v-col>
              <v-col cols="12">
                <BaseTextarea
                  v-model="email_teste"
                  :label="$t('marketing.invitation.send-test-email-to')"
                  persistent-placeholder
                />
              </v-col>
              <v-col cols="12">
                <BaseTextField
                  :label="$t('marketing.invitation.template-name')"
                  v-model="nome_template"
                  :placeholder="$t('marketing.invitation.define-template-name')"
                  persistent-placeholder
                />
              </v-col>
              <v-col cols="12" align="center" class="mt-16">
                <BaseButton
                  tabindex="13"
                  variant="outlined"
                  large
                  class="button rounded-pill font-weight-bold border-render"
                  block
                  type="submit"
                >
                  <v-icon class="pa-2">mdi-email-plus-outline</v-icon>
                  {{ $t("marketing.invitation.send-test-email") }}
                </BaseButton>
                <BaseButton
                  tabindex="13"
                  variant="outlined"
                  large
                  block
                  class="button rounded-pill font-weight-bold border-render mt-2"
                  @click="saveAsDraft()"
                >
                  <v-icon class="pa-2">mdi-file-check-outline</v-icon>
                  {{ $t("marketing.invitation.save-as-template") }}
                </BaseButton>
              </v-col>
            </v-form>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card
          flat
          v-if="showEventInvitePage()"
          height="80%"
          class="rounded-t-xl"
        >
          <v-system-bar
            height="100"
            color="tertiary"
            width="100%"
            class="pa-0 ma-0 justify-center flex-column rounded-t-xl"
          >
            <v-card-subtitle class="pa-0">
              <span class="text-h6 font-weight-bold d-flex white--text">
                {{ infoEvent.loja_nome }}
              </span>
            </v-card-subtitle>
            <v-card-subtitle class="pa-0">
              <span class="text-h8 font-weight-bold d-flex white--text mr-5">
                {{ $t("marketing.invitation.shared-this-event") }}
              </span>
            </v-card-subtitle>
          </v-system-bar>
          <v-row>
            <v-col cols="12" class="pa-8 mt-n5">
              <v-row class="mt-3" style="max-height: 60px !important">
                <v-col cols="6" style="max-height: 15px !important">
                  <span
                    style="
                      color: #999999;
                      font-family: 'Archivo', sans-serif;
                      font-size: 14px;
                      margin-left: 20px;
                    "
                    >{{ $t("marketing.invitation.event") }}:</span
                  >
                  <span
                    class="font-weight-bold"
                    style="margin-left: 14px !important"
                    >{{ infoEvent.descricao }}</span
                  >
                </v-col>
                <v-col cols="6" class="d-flex justify-end">
                  <v-img
                    :src="highlightImg"
                    class="white--text align-end rounded-lg mb-5"
                    :max-height="maxHeight"
                    :max-width="maxWidth"
                  >
                  </v-img>
                </v-col>
              </v-row>
              <v-col cols="12">
                <span
                  style="
                    color: #999999;
                    font-family: 'Archivo', sans-serif;
                    font-size: 14px;
                    margin-left: 12px;
                  "
                >
                  {{ $t("marketing.invitation.organized-by") }}:
                </span>
                <span
                  class="font-weight-bold"
                  style="margin-left: 14px !important"
                >
                  {{ infoEvent.loja_nome }}
                </span>
              </v-col>
              <v-col cols="12">
                <span
                  style="
                    color: #999999;
                    font-family: 'Archivo', sans-serif;
                    font-size: 14px;
                    margin-left: 12px;
                  "
                >
                  {{ $t("marketing.invitation.event-location") }}:
                </span>
                <span class="font-weight-bold">
                  {{ this.optionsLocal }}
                </span>
              </v-col>
              <v-col cols="12">
                <span
                  style="
                    color: #999999;
                    font-family: 'Archivo', sans-serif;
                    font-size: 14px;
                    margin-left: 12px;
                  "
                >
                  {{ $t("marketing.invitation.date") }}:
                </span>
                <span class="font-weight-bold">
                  {{ this.optionsData }}
                </span>
              </v-col>
              <v-col cols="12">
                <div color="black" height="20" width="100%"></div>
              </v-col>
              <v-row class="mx-n5">
                <v-divider class="dividers"></v-divider>
              </v-row>
              <v-col cols="12">
                <v-container class="mb-16">
                  <v-row>
                    <v-col>
                      <span
                        style="
                          color: #999999;
                          font-family: 'Archivo', sans-serif;
                          font-size: 14px;
                          margin-left: 5px;
                        "
                      >
                        {{ $t("marketing.invitation.message") }}:
                      </span>
                      <span
                        class="font-weight-bold"
                        style="margin-left: 14px !important"
                        v-html="mensagem"
                      >
                      </span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-col>
          </v-row>
          <v-col class="d-flex justify-center">
            <BaseButton
              bottom
              tabindex="13"
              variant="filter"
              class="button rounded-pill"
            >
              {{ $t("marketing.invitation.learn-more") }}
            </BaseButton>
          </v-col>
          <v-system-bar
            height="80"
            color="tertiary"
            width="100%"
            class="pa-0 ma-0 justify-center flex-column"
          >
            <v-img
              src="/playground_assets/Eleven_Tickets_Negativo_Horizontal.svg"
              width="150"
              height="90"
              contain
            ></v-img>
          </v-system-bar>
        </v-card>
        <v-card flat v-if="!showEventInvitePage()" class="rounded-t-xl">
          <v-system-bar
            height="100"
            color="tertiary"
            width="100%"
            class="pa-0 ma-0 justify-center flex-column rounded-t-xl"
          >
            <v-card-subtitle class="pa-0">
              <span class="text-h6 font-weight-bold d-flex white--text">
                {{ storeInfo.nome_loja }}
              </span>
              <span class="text-h6 font-weight-bold d-flex white--text">
                {{ this.$axios.getLocal("oe_user_info").data?.slug }}
              </span>
            </v-card-subtitle>
            <v-card-subtitle class="pa-0">
              <span class="text-h8 font-weight-bold d-flex white--text mr-5">
                {{ $t("marketing.invitation.shared-this-event") }}
              </span>
            </v-card-subtitle>
          </v-system-bar>
          <v-row>
            <v-col cols="12" class="pa-8 mt-n5">
              <v-col cols="12">
                <v-container class="mb-16">
                  <v-row>
                    <v-col>
                      <span
                        style="
                          color: #999999;
                          font-family: 'Archivo', sans-serif;
                          font-size: 14px;
                          margin-left: 5px;
                        "
                      >
                        {{ $t("marketing.invitation.message") }}:
                      </span>
                      <span
                        class="font-weight-bold"
                        style="margin-left: 14px !important"
                        v-html="mensagem"
                      >
                      </span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-col>
          </v-row>
          <v-col class="d-flex justify-center">
            <BaseButton
              bottom
              min-width="180"
              tabindex="13"
              variant="filter"
              class="button rounded-pill"
            >
              {{ $t("marketing.invitation.learn-more") }}
            </BaseButton>
          </v-col>
          <v-system-bar
            height="80"
            color="tertiary"
            width="100%"
            class="pa-0 ma-0 justify-center flex-column"
          >
            <v-img
              src="/playground_assets/Eleven_Tickets_Negativo_Horizontal.svg"
              width="150"
              height="90"
              contain
            ></v-img>
          </v-system-bar>
        </v-card>
      </v-col>
    </v-row>
  </fragment>
</template>

<script>
import BaseTextField from "@/components/forms/BaseTextField.vue";
import displayHelpers from "@/mixins/breakpoints.mixins";
import BaseButton from "@/components/forms/BaseButton.vue";
import editor from "@/components/global/editor.vue";
import mixins from "@/mixins";
import BaseTextarea from "@/components/forms/BaseTextarea.vue";
// eslint-disable-next-line no-unused-vars
import { formatDate } from "@/utils";
// eslint-disable-next-line no-unused-vars
import { mapGetters, mapActions } from "vuex";
const { formRules } = mixins;
export default {
  name: "InviteForm",
  mixins: [displayHelpers, formRules],
  data() {
    return {
      status: "ATIVO",
      finalizado: 0,
      email_evento: 0,
      assunto: "",
      remetente: "",
      mensagem: "",
      idproduto: "",
      idusuario: "",
      nome_evento: "",
      data_evento: "",
      local_evento: "",
      nome_template: "",
      email_teste: "",
      organizador: "",
      loja: "",
      nome: "",
      customToolbar: [
        ["image"],
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6],
          },
        ],
        ["bold", "italic"], // toggled buttons
        [
          {
            align: "",
          },
          {
            align: "center",
          },
          {
            align: "right",
          },
          {
            align: "justify",
          },
        ],
        ["clean"],
        [
          {
            indent: "-1",
          },
          {
            indent: "+1",
          },
        ], // outdent/indent
        [
          {
            list: "ordered",
          },
          {
            list: "bullet",
          },
        ],
      ],
    };
  },
  components: {
    BaseButton,
    BaseTextField,
    BaseTextarea,
    editor,
  },
  computed: {
    ...mapGetters([
      "sendInviteEvent",
      "storeSequencial",
      "storeInfo",
      "setInfo",
      "getTypeInvite",
      "getInfoRegister",
      "inviteImages",
    ]),
    maxHeight() {
      return this.mdAndUp ? "190" : "90";
    },
    maxWidth() {
      return this.mdAndUp ? "210" : "90";
    },
    highlightImg() {
      return (
        this.infoEvent?.imagens?.destaque || this.infoEvent?.imagens?.imagem1
      );
    },
    optionsData() {
      if (this.infoEvent.dthr_apresentacao !== null) {
        return this.infoEvent.dthr_apresentacao;
      } else return "Data e hora ainda não divulgados";
    },
    optionsLocal() {
      if (this.infoEvent.end_local !== "") {
        return this.infoEvent.end_local;
      } else return "Local do evento não divulgado";
    },
    infoEvent() {
      return JSON.parse(localStorage.getItem("eventoData"));
    },
  },
  methods: {
    ...mapActions([
      "setSendInvite",
      "setImages",
      "setRegisterInvitation",
      "setEditInvitation",
    ]),
    getEditInfo() {
      if (this.getTypeInvite == "edit") {
        if (this.showEventInvitePage()) {
          const {
            idloja,
            idemail_marketing,
            email_evento,
            nome,
            corpo,
            nome_evento,
            data_evento,
            local_evento,
            organizador,
            importa_dados,
            dthr_aceite_termo,
            assunto,
            remetente,
            idproduto,
            status,
          } = this.getInfoRegister;

          this.assunto = assunto;
          this.mensagem = corpo;
          this.remetente = remetente;
          this.nome_template = nome;
          this.email_evento = email_evento;
          this.idemail_marketing = idemail_marketing;
          this.storeInfo.idloja = idloja;
          this.infoEvent.descricao = nome_evento;
          this.infoEvent.dthr_apresentacao = data_evento;
          this.infoEvent.end_local = local_evento;
          this.infoEvent.loja_nome = organizador;
          this.importa_dados = importa_dados;
          this.dthr_aceite_termo = dthr_aceite_termo;
          this.infoEvent.idproduto = idproduto;
          this.status = status;
        } else {
          const {
            idloja,
            idemail_marketing,
            email_evento,
            nome,
            corpo,
            importa_dados,
            dthr_aceite_termo,
            assunto,
            remetente,
            status,
          } = this.getInfoRegister;
          this.assunto = assunto;
          this.mensagem = corpo;
          this.remetente = remetente;
          this.nome_template = nome;
          this.email_evento = email_evento;
          this.idemail_marketing = idemail_marketing;
          this.storeInfo.idloja = idloja;
          this.importa_dados = importa_dados;
          this.dthr_aceite_termo = dthr_aceite_termo;
          this.status = status;
        }
      } else {
        this.getInfoRegister = {
          status: "ATIVO",
          finalizado: 0,
          email_evento: 0,
          assunto: "",
          remetente: "",
          mensagem: "",
          idproduto: "",
          idusuario: "",
          nome_evento: "",
          data_evento: "",
          local_evento: "",
          organizador: "",
          loja: "",
          nome: "",
        };
      }
    },
    showEventInvitePage() {
      if (this.infoEvent !== null) {
        return true;
      }
      return false;
    },
    sendTestInvite() {
      if (this.showEventInvitePage()) {
        const email = this.email_teste.replace(/\s*,\s*/g, ";");
        let data = {
          assunto: this.assunto,
          remetente: this.remetente,
          corpo: this.mensagem,
          idproduto: this.infoEvent.idproduto,
          idusuario: "",
          email: email,
          nome_evento: this.infoEvent.descricao,
          data_evento:
            this.infoEvent.dthr_apresentacao == ""
              ? "Data não divulgada"
              : this.infoEvent.dthr_apresentacao,
          local_evento:
            this.infoEvent.end_local == ""
              ? "Local não divulgado"
              : this.infoEvent.end_local,
          organizador: this.infoEvent.loja_nome,
          loja: this.storeSequencial,
        };
        this.setSendInvite(data);
      } else {
        const email = this.email_teste.replace(/\s*,\s*/g, ";");
        let data_produtor = {
          assunto: this.assunto,
          remetente: this.remetente,
          corpo: this.mensagem,
          idusuario: "",
          email: email,
          loja: this.storeSequencial,
        };
        this.setSendInvite(data_produtor);
      }
    },
    async saveAsDraft() {
      if (this.getTypeInvite !== "edit") {
        if (this.showEventInvitePage()) {
          try {
            let data = {
              status: "ATIVO",
              finalizado: 0,
              email_evento: 0,
              assunto: this.assunto,
              remetente: this.remetente,
              corpo: this.mensagem,
              idproduto: this.infoEvent.idproduto,
              idusuario: "",
              nome_evento: this.infoEvent.descricao,
              data_evento:
                this.infoEvent.dthr_apresentacao == ""
                  ? "Data não divulgada"
                  : this.infoEvent.dthr_apresentacao,
              local_evento:
                this.infoEvent.end_local == ""
                  ? "Local não divulgado"
                  : this.infoEvent.end_local,
              organizador: this.infoEvent.loja_nome,
              loja: this.storeSequencial,
              nome: this.nome_template,
            };
            await this.setRegisterInvitation(data);
          } catch (error) {
            console.log(error);
          }
        } else {
          let data_produtor = {
            status: "ATIVO",
            finalizado: 0,
            email_evento: 0,
            assunto: this.assunto,
            remetente: this.remetente,
            corpo: this.mensagem,
            idusuario: "",
            loja: this.storeSequencial,
            nome: this.nome_template,
          };
          this.setRegisterInvitation(data_produtor);
        }
      } else {
        if (this.showEventInvitePage()) {
          let data = {
            status: "ATIVO",
            finalizado: 0,
            email_evento: 0,
            assunto: this.assunto,
            remetente: this.remetente,
            corpo: this.mensagem,
            idemail_marketing: this.idemail_marketing,
            idusuario: "",
            idproduto: this.infoEvent.idproduto,
            nome_evento: this.infoEvent.descricao,
            data_evento:
              this.infoEvent.dthr_apresentacao == ""
                ? "Data não divulgada"
                : this.infoEvent.dthr_apresentacao,
            local_evento:
              this.infoEvent.end_local == ""
                ? "Local não divulgado"
                : this.infoEvent.end_local,
            organizador: this.infoEvent.loja_nome,
            loja: this.storeSequencial,
            nome: this.nome_template,
          };
          this.setEditInvitation(data);
        } else {
          let data_produtor = {
            status: "ATIVO",
            finalizado: 0,
            email_evento: 0,
            assunto: this.assunto,
            remetente: this.remetente,
            corpo: this.mensagem,
            idusuario: "",
            loja: this.storeSequencial,
            nome: this.nome_template,
            idemail_marketing: this.idemail_marketing,
          };
          this.setEditInvitation(data_produtor);
        }
      }
    },
    resetFields() {
      this.assunto = "";
      this.remetente = "";
      this.mensagem = "";
      this.nome_template = "";
      this.email_teste = "";
    },
  },
  watch: {
    "$store.getters.getInfoRegister"() {
      return this.getEditInfo();
    },
    // eslint-disable-next-line no-unused-vars
    testeForm(newVal, oldVal) {
      if (newVal === "success") {
        this.$refs.inviteForm.resetFields();
      }
    },
  },
};
</script>

<style scoped>
.heigh-input {
  height: 350px !important;
}
.dividers {
  border-color: #2d1a4c !important;
  border: 5px solid;
}
.system-bar {
  display: flex;
  flex-direction: column !important;
}
.editor-container {
  min-height: 500px;
  background-color: blue !important;
  border-radius: 30px;
}

.border-render {
  border: 2px solid #999999 !important;
}
.editor-input {
  height: 350px !important;
  width: 100%;
  margin-top: 0.375rem;
  margin-bottom: 0.625rem;
  background: #fff;
  overflow: auto;
  border-top-left-radius: 1.25rem;
  border-top-right-radius: 1.25rem;
  border-bottom-left-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  -webkit-box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.registration-actions-sticky {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end !important;
  padding-top: 0.625rem;

  position: sticky;
  bottom: -20px;
  z-index: 1;
  background-color: #eaeaea;
}

.registration-actions-fixed {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end !important;
  padding: 0.5rem;
  position: fixed;
  bottom: 0;
  left: 0;
}
</style>
